import GeoDirection from '@/directions/types/GeoDirection'
import User from '@/models/User'
import i18n from '@/i18n/index'

export default class CurrentLocation {
	public static async getCurrentLocation(): Promise<GeoDirection | null> {
		const vesselLocation = await CurrentLocation.parseLocationFromVessel()

		if (vesselLocation) {
			return vesselLocation
		}

		if (!('geolocation' in navigator)) {
			return null
		}

		return new Promise((resolve, reject) => {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					const geoDirection = new GeoDirection()
					geoDirection.text = i18n.t('map.directions.current_location_geolocation').toString()
					geoDirection.geo = {
						coordinates: [position.coords.longitude, position.coords.latitude],
						type: 'Point'
					}

					resolve(geoDirection)
				},
				() => {
					resolve(null)
				}
			)
		})
	}

	public static async parseLocationFromVessel(): Promise<GeoDirection | null> {
		const vessels = await User.getCurrentVessels()

		if (!vessels.length || !vessels[0].getLocation()) {
			return null
		}

		const location = vessels[0].getLocation() as GeoJSON.Point

		const geoDirection = new GeoDirection()
		geoDirection.text = i18n
			.t('map.directions.current_location', {
				vessel: vessels[0].getName()
			})
			.toString()
		geoDirection.geo = {
			coordinates: location.coordinates,
			type: 'Point'
		}

		return geoDirection
	}
}
